import { TicketClassCategory } from '../../constants';
import { CheckoutState } from '../../state';
import { getNamespaceValue } from '../utils/selector';

export const getConstrainedInstrumentType = (state: CheckoutState) =>
    getNamespaceValue(state.tickets, 'constrainedInstrumentType', null);

export const getConstrainedPaymentMethods = (state: CheckoutState) =>
    getNamespaceValue(state.tickets, 'constrainedPaymentMethods', []);

export const getTicketsById = (state: CheckoutState) =>
    getNamespaceValue(state.tickets, 'ticketsById', {});

export const getTicketIds = (state: CheckoutState) =>
    getNamespaceValue(state.tickets, 'ticketIds', []);

export const areAdmissionTicketsAvailable = (state: CheckoutState) =>
    !!state.tickets.ticketIds.find((ticketId) => {
        const ticket = state.tickets.ticketsById[ticketId];
        return (
            ticket.category === TicketClassCategory.admission &&
            !ticket.isDisabled
        );
    });
